import { globalGrafanaReporter as _globalGrafanaReporter } from '@fiverr-private/identification_core';
import { GRAFANA_PREFIX } from './grafana.constants';
import { GrafanaEventName } from './grafana.types';

export const globalGrafanaReporter = _globalGrafanaReporter.extend<GrafanaEventName>({ grafanaPrefix: GRAFANA_PREFIX });
